const useKeyboardShortcut = () => null;
export default useKeyboardShortcut;
